var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',{attrs:{"colspan":"3"}}),_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("Buy")]),_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("Sell")])])
}]

export { render, staticRenderFns }